import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@netx/core-icons';
import {canSharePdfFromSavedSearch} from '../enablers';
import {SEARCH_SAVED_ACTION_LABELS} from '../locales';
import {type SavedSearch} from '../types';
import {SEARCH_SAVED_EVENT} from './constants';

export const searchSavedActionCreatePDFShareLinkIcon = faLink;

/**
 * Create pdf share link from saved search assets
 * @param params
 * @returns Action
 */
export const searchSavedActionCreatePDFShareLink = (
	savedSearch?: SavedSearch,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-search-create-pdf-share-link',
	cb: () =>
		dispatcher.trigger(SEARCH_SAVED_EVENT.CREATE_PDF_SHARE_LINK, savedSearch),
	enableTest: () => canSharePdfFromSavedSearch(savedSearch),
	icon: searchSavedActionCreatePDFShareLinkIcon,
	get label() {
		return SEARCH_SAVED_ACTION_LABELS.CREATE_PDF_SHARE_LINK;
	},
	...params,
});

export default searchSavedActionCreatePDFShareLink;
